module.exports = __webpack_public_path__ + "0b145ad2367e124868d703d68c6f0d49.jpg";